import { combineReducers } from 'redux';
import confirmToLogin from './confirmToLogin';
import sso from './sso';
import twoFactorAuth from './twoFactorAuth';
// @ts-expect-error reducer not yet converted
import twoFactorRecovery from './twoFactorRecovery';
const rootReducer = combineReducers({
  confirmToLogin,
  sso,
  twoFactorAuth,
  twoFactorRecovery
});
export default rootReducer;